import { noSpecialCharsRegex } from '../../../regex';
import {
  maxClasseDateChallenge,
  minClasseDateChallenge
} from '../../../../types/classe/classe.def';

const requis = '^Ce champ est requis';
const maxMessage = 'Le champ ne doit pas contenir plus de ';

export const formCreateClasseSchema = {
  classeName: {
    presence: { allowEmpty: false, message: requis },
    length: {
      maximum: 32,
      message: `^${maxMessage} 32 caractères`
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: `^Le nom ne doit pas comporter de caractères spéciaux`
    }
  },
  filliere: {
    presence: { allowEmpty: false, message: requis }
  },
  niveau: {
    presence: { allowEmpty: false, message: requis }
  },
  debut: {
    presence: { allowEmpty: false, message: requis },
    datetime: {
      dateOnly: true,
      earliest: minClasseDateChallenge,
      latest: maxClasseDateChallenge,
      message:
        'Vous ne pouvez pas fixer une date de début antérieure à celle du challenge'
    }
  },
  fin: {
    presence: { allowEmpty: false, message: requis },
    datetime: {
      dateOnly: true,
      earliest: minClasseDateChallenge,
      latest: maxClasseDateChallenge,
      message:
        'Vous ne pouvez pas fixer une date de fin ultérieure à celle du challenge'
    }
  }
};
